module.exports = __webpack_public_path__ + "Server-Default.TentacleActive.ff5a0208bb76c5ce86a40bdc4622f3a5.hashedasset.svg";